/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_273c406c"]'><cube-modal ref="__mpx_ref_modal__" type="onConfirm" title="我是标题~" content="我是正文正文" confirm-btn="一个按钮" cancel-text="取消" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'/><cube-button @_click="onTap">modal-with-cancel</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_273c406c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_273c406c"}
  /** script content **/
  require("./modal-with-cancel.mpx.js?isComponent&outputPath=components%2Fmodal-with-cancel273c406c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-with-cancel.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-with-cancel273c406c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_273c406c"],
    ctorType: "component",
    outputPath: "components/modal-with-cancel273c406c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>